import { SERVER_URLS } from "../../../appConstants";
import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { getToken } from "../../authentication";

export const sendNotifications = (notificationsToSend) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/marketing/notifications/send"
            const response = await fetch(url,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ notificationsToSend })
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data?.revenueOverview);
            } else {
                reject(
                    data?.message || "Something went wrong while sending notifications."
                );
            }
        } catch (error) {
            reject("Something went wrong while sending notifications.");
        }
    });
};

export const sendTextNotifications = (templateId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = SERVER_URLS.BACKEND_SERVER + `/bhumeet_team/marketing/notifications/text/${templateId}`
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data);
            } else {
                reject(
                    data?.message || "Something went wrong while sending text notifications."
                );
            }
        } catch (error) {
            reject("Something went wrong while sending text notifications.");
        }
    });
};


export const getNotificationHistory = (pageNumber,pageSize,fromDate,toDate,interval) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + '/bhumeet_team/operations/marketing/history', {
                pageNumber,
                pageSize,
                fromDate,
                toDate,
                interval
            })
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data);
            } else {
                reject(
                    data?.message || "Something went wrong while getting stores."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting stores.");
        }
    });
};

export const getTextNotificationHistory = (pageNumber,pageSize,fromDate,toDate,interval) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + '/bhumeet_team/operations/marketing/textNotificationhistory', {
                pageNumber,
                pageSize,
                fromDate,
                toDate,
                interval
            })
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data);
            } else {
                reject(
                    data?.message || "Something went wrong while getting stores."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting stores.");
        }
    });
};